var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuaranteeLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.42836 6.00027V10.286H8.57121V6.00027H1.42836ZM0.405424 4.97734C0.68241 4.70035 1.05175 4.5717 1.42836 4.5717H8.57121C8.94782 4.5717 9.31716 4.70035 9.59415 4.97734C9.87113 5.25432 9.99979 5.62367 9.99979 6.00027V10.286C9.99979 10.6626 9.87113 11.0319 9.59415 11.3089C9.31716 11.5859 8.94782 11.7146 8.57121 11.7146H1.42836C1.05175 11.7146 0.68241 11.5859 0.405424 11.3089C0.128439 11.0319 -0.000213623 10.6626 -0.000213623 10.286V6.00027C-0.000213623 5.62367 0.128439 5.25432 0.405424 4.97734Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99996 1.714C3.82302 1.714 2.8571 2.67992 2.8571 3.85686V5.28543C2.8571 5.67992 2.5373 5.99972 2.14281 5.99972C1.74832 5.99972 1.42853 5.67992 1.42853 5.28543V3.85686C1.42853 1.89094 3.03404 0.285431 4.99996 0.285431C6.96587 0.285431 8.57138 1.89094 8.57138 3.85686V5.28543C8.57138 5.67992 8.25159 5.99972 7.8571 5.99972C7.46261 5.99972 7.14281 5.67992 7.14281 5.28543V3.85686C7.14281 2.67992 6.1769 1.714 4.99996 1.714Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuaranteeLock);
export default __webpack_public_path__ + "static/media/guarantee-lock.e5249016dc6fa8f437bb8c7146449031.svg";
export { ForwardRef as ReactComponent };